export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.08 50.09">
    <path d="M25 50.09A25 25 0 1 1 50.08 25 25.07 25.07 0 0 1 25 50.09zm0-48A22.92 22.92 0 1 0 48 25 22.94 22.94 0 0 0 25 2.13z" />
    <path d="M19.26 21h2.48v-2.42a6.37 6.37 0 0 1 .8-3.72 4.39 4.39 0 0 1 3.84-1.81 15.5 15.5 0 0 1 4.45.45l-.62 3.67a8.42 8.42 0 0 0-2-.3c-1 0-1.83.35-1.83 1.31V21h4l-.28 3.59h-3.72V37h-4.64V24.57h-2.49V21z" />
  </svg>
);
